window.addEventListener('load', (event) => {
    console.log('The page has fully loaded');



    // Function to update the cart note
    function updateCartNote(note) {
        // Construct the data to be sent in the request
        const data = {
            note: note
        };

        // Send a POST request to the /cart/update.js endpoint
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to update cart note');
            }
            // Handle successful response
            console.log('Cart note updated successfully');
        })
        .catch(error => {
            console.error('Error updating cart note:', error);
        });
    }



    // Flag to track whether the HTML content has been added
    let customFieldsAdded = false;

  // Function to append HTML and set up event listeners
    function setupCustomFields() {
      setTimeout(function(){
        
        const slideCart = document.getElementById('slidecarthq')
        const note = slideCart.querySelector('.note');

        if (!customFieldsAdded) {
            

            // Insert HTML content just after the note
            //note.insertAdjacentHTML('beforebegin', '<div class="cart-custom-fields"><h5 for="custom_field">Please choose the department code that correspond this order:</h5><div class="line-field"><input type="radio" id="option1" name="custom_field" value="415 - Child care (Ages 0-4 years)"><label for="option1">415 - Child care (Ages 0-4 years)</label></div><div class="line-field"><input type="radio" id="option2" name="custom_field" value="425 - Kindergarten"><label for="option2">425 - Kindergarten</label><br></div><div class="line-field"><input type="radio" id="option3" name="custom_field" value="435 - School age"><label for="option3">435 - School age</label><br></div><div class="line-field"><input type="radio" id="option4" name="custom_field" value="5347 -  Summer Club expenses "><label for="option3">5347 -  Summer Club expenses </label><br></div>');
         note.insertAdjacentHTML('beforebegin', ' <div class="cart-custom-fields"> ' +
            ' <h5 for="custom_field">Please choose the department code that correspond this order:</h5>' +
            ' <div class="line-field"><input type="radio" id="option1" name="custom_field" value="415 - Child care (Ages 0-4 years)" /><label for="option1">415 - Child care (Ages 0-4 years)</label></div>' +
            '<div class="line-field"><input type="radio" id="option2" name="custom_field" value="425 - Kindergarten" /><label for="option2">425 - Kindergarten</label><br /></div>' +
            '<div class="line-field"><input type="radio" id="option3" name="custom_field" value="435 - School age" /><label for="option3">435 - School age</label><br /></div>' +
            '<div class="line-field"><input type="radio" id="option4" name="custom_field" value="412 – EarlyOn"><label for="option4">412 - EarlyOn  (Include your budget code in the notes)</label><br></div>'
        ); 

            // Set the flag to true to indicate that the HTML content has been added
            customFieldsAdded = true; 
        }
        

         setTimeout(function(){
            
             // Add event listener to radio buttons
            const radioButtons = document.querySelectorAll('input[name="custom_field"]');
            radioButtons.forEach(radioButton => {
                radioButton.addEventListener('change', () => {

                    const noteTrigger = document.querySelector('.note .note-trigger');
                    const selectedValue = document.querySelector('input[name="custom_field"]:checked').value;
                    const noteTextAreaLoad = note.querySelector('.note-body textarea');                    


                     // Simulate click event on the note-trigger element
                    if (noteTrigger && noteTextAreaLoad == null ) {
                        noteTrigger.click();
                    } else {
                        console.log('Note trigger element not found.');
                    }

                    setTimeout(function(){
                        const noteTextArea = note.querySelector('.note-body textarea');
                        
                  
                        setTimeout(function(){
                            console.log('selectedValue ' + selectedValue)
                            if (noteTextArea != null){
                                noteTextArea.value = 'Department code that correspond this order: ' + selectedValue;
                            }                            
                            
                            setTimeout(function(){                                                              
                                // Usage example: Update the cart note to 'New note text'
                                updateCartNote('Department code that correspond this order: ' + selectedValue);                                

                            }, 950);                                                         

                        }, 250); 
                    }, 300); 
                                        
                    
                });
            }); 

         }, 600); 
         

      }, 2000);        
    }


   
    setTimeout(() => {
        console.log("Retrasado por 1 segundo.");
        // Call the function once on page load in case there are already products in the cart
        
        const slideCartLoad = document.getElementById('slidecarthq')       
        if(slideCartLoad != null){            
            setupCustomFields();
        }


        // Listen for clicks on the add-to-cart button
        const addToCartButton = document.getElementById('add-to-cart-button');
        if (addToCartButton) {
            addToCartButton.addEventListener('click', () => {
                // Call the function to append HTML and set up event listeners                
                setupCustomFields();
            });
        }
    
        
      }, 1900);



      /* SCRIPT FOR CART PAGE */ 
      const radioButtons = document.querySelectorAll('input[name="properties[depart_code]"]');
      const orderNoteFieldCart = document.getElementById('CartOrderNote');
      // Function to handle radio button change
        function handleRadioChange(event) {
            const selectedValue = event.target.value;
            
            orderNoteFieldCart.value = 'Department code that correspond this order: ' + selectedValue;
            // Call the updateCartNote function with the selected value
            updateCartNote('Department code that correspond this order: ' + selectedValue);
        }

      

      if(radioButtons && radioButtons != null ){
        // Add event listener to each radio button
        radioButtons.forEach(radioButton => {
            radioButton.addEventListener('change', handleRadioChange);
        });
      }
        

    
});
 